/**
 * Environment configuration. Vite injects VITE_* at build time.
 * Use `||` (not `??`) so empty .env values cannot override baked-in fallbacks.
 */
const trim = (v: unknown): string => (typeof v === "string" ? v.trim() : "");

export const SUPABASE_URL =
  trim(import.meta.env.VITE_SUPABASE_URL) || "https://xpifuwgmwgtawevpeskr.supabase.co";

export const SUPABASE_ANON_KEY =
  trim(import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY) ||
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhwaWZ1d2dtd2d0YXdldnBlc2tyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI4ODY0NzQsImV4cCI6MjA4ODQ2MjQ3NH0.3fQY_BL9BQ3FJXb49NGPpAVji9SieFZfvi2tjdJh704";

export const IS_DEV = import.meta.env.DEV;

/** True only for Straiv Dev (browser `npm run dev` or `sync:ios:dev`). Never on App Store. */
export const IS_DEV_APP =
  trim(import.meta.env.VITE_APP_ENV) === "dev" ||
  SUPABASE_URL.includes("xpifuwgmwgtawevpeskr");

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  console.error("[STRAIV] Missing Supabase configuration — auth will not work.");
}
